import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { SERVICES_NAV_LINKS } from 'utils/Navbarutils';

const ServiceDropdown = ({ toggleMenu }) => {
  const [isServiceDropdownOpen, setIsServiceDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isMobileMode, setIsMobileMode] = useState(false);

  const handleMouseEnter = () => {
    if (!isMobileMode) {
      setIsServiceDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobileMode) {
      setIsServiceDropdownOpen(false);
    }
  };

  const handleNavigationclose = () => {
    setIsServiceDropdownOpen(false);
    if (isMobileMode && toggleMenu) toggleMenu();
  };

  const handleServiceClick = () => {
    if (isMobileMode) {
      setIsMobileDropdownOpen(!isMobileDropdownOpen);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileMode(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMobileDropdownOpen(false);
        setIsServiceDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={dropdownRef}
      className="relative"
    >
      <div 
        className="px-2 py-2 text-white rounded-md cursor-pointer select-none font-normal text-base hover:text-cyan-400 transition-colors flex items-center gap-1.5" 
        onClick={handleServiceClick}
      >
        <span>Services</span>
        <FontAwesomeIcon icon={faAngleDown} className={`text-xs transition-transform duration-200 ${isServiceDropdownOpen || isMobileDropdownOpen ? 'rotate-180' : ''}`} />
      </div>

      {/* Mobile Screens */}
      {isMobileMode && isMobileDropdownOpen && (
        <div className="w-full py-2 px-3 mt-1 bg-neutral-900 border-l-2 border-cyan-500 rounded-md">
          <ul className="space-y-1">
            {SERVICES_NAV_LINKS.map(({ id, label, path }) => (
              <li key={id}>
                <Link
                  to={path}
                  onClick={handleNavigationclose}
                  className="block py-2 px-3 text-sm text-gray-200 hover:text-cyan-400 hover:bg-neutral-800 rounded transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Desktop Screens */}
      {!isMobileMode && isServiceDropdownOpen && (
        <div className="absolute pt-3 top-full left-0 min-w-[340px] z-50 animate-fadeIn">
          <div className="bg-[#0b1120] border border-cyan-500/20 rounded-xl shadow-2xl p-3 backdrop-blur-md">
            <div className="px-3 py-1.5 mb-1 text-[11px] font-semibold uppercase tracking-wider text-cyan-400 border-b border-gray-800/80">
              Core Engineering Services
            </div>
            <ul className="space-y-1 pt-1">
              {SERVICES_NAV_LINKS.map(({ id, label, path, description }) => (
                <li key={id}>
                  <Link
                    to={path}
                    onClick={handleNavigationclose}
                    className="block p-2.5 rounded-lg hover:bg-white/5 transition-all group"
                  >
                    <div className="text-sm font-medium text-gray-100 group-hover:text-cyan-300 transition-colors">
                      {label}
                    </div>
                    {description && (
                      <div className="text-xs text-gray-400 line-clamp-1 mt-0.5 font-light">
                        {description}
                      </div>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceDropdown;

